import React from "../../../__snowpack__/pkg/react.js";
export const cascaderFilter = (inputValue, path) => {
  return path.some((option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
};
export const cascaderRender = (inputValue, path) => {
  let items = path.map((item) => {
    const startIdx = item.name.toLowerCase().indexOf(inputValue.toLowerCase());
    if (startIdx > -1) {
      const startStr = item.name.substr(0, startIdx);
      const middleStr = item.name.substr(startIdx, inputValue.length);
      const endStr = item.name.substr(startIdx + inputValue.length, item.name.length - (startIdx + inputValue.length));
      const highlightStr = /* @__PURE__ */ React.createElement(React.Fragment, null, startStr, /* @__PURE__ */ React.createElement("span", {
        style: {color: "#fe4d4f"}
      }, middleStr), endStr);
      return highlightStr;
    }
    return item.name;
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, " ", items.map((item, index) => {
    if (items.length > 1 && index < items.length - 1) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, " ", item, " / ");
    }
    return item;
  }));
};
